import React, { useState } from "react";
import classes from "./Accordion.module.css";
import plus from "../../../assets/icons/plus.svg";
import close from "../../../assets/icons/close.svg";
import CustomIcon from "../CustomIcon/CustomIcon";

const Accordion = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={classes.accordion}>
      <button className={classes.accordion_header} onClick={toggleAccordion}>
        {isExpanded ? (
          <CustomIcon src={close} iconHeight={12} iconWidth={12} />
        ) : (
          <CustomIcon src={plus} iconHeight={12} iconWidth={12} />
        )}
        <div>{title}</div>
      </button>
      {isExpanded && <div className={classes.accordion_content}>{content}</div>}
    </div>
  );
};

export default Accordion;
